import type { FileItem } from "@services/api";
import { Button, message } from "antd";
import type { ButtonProps } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { useDownloadFile } from "./useDownloadFile";

interface DownloadButtonProps extends Omit<ButtonProps, "onClick"> {
    file: FileItem;
    label?: string; // если не передать — покажем children или "Скачать"
}

export default function DownloadButton({
    file,
    label,
    children,
    type = "default",
    size = "middle",
    icon = <DownloadOutlined />,
    style,
    ...rest
}: DownloadButtonProps) {
    const { download, loading } = useDownloadFile();

    const handleClick = async () => {
        try {
            await download(file);
        } catch (err) {
            message.error("Не удалось скачать файл");
            // eslint-disable-next-line no-console
            console.error(err);
        }
    };

    return (
        <Button
            type={type}
            size={size}
            icon={icon}
            loading={loading}
            onClick={handleClick}
            style={{ minWidth: 260, ...style }}
            {...rest}
        >
            {label ?? children ?? "Скачать"}
        </Button>
    );
}
